import { render } from "./makala.vue?vue&type=template&id=b131ae5c&scoped=true"
import script from "./makala.vue?vue&type=script&lang=js"
export * from "./makala.vue?vue&type=script&lang=js"

import "./makala.vue?vue&type=style&index=0&id=b131ae5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b131ae5c"

export default script